export const FUND_PERMISSION_NAME = 'Fund';
export const FIRM_PERMISSION_NAME = 'Firm';
export const NEW_FIRM_SLUG = 'new-firm';
export const ITEM_HEIGHT = 350;
export const USER_MENU_SLUG = 'user-menu';
export const FIRMS_MENU_SLUG = 'firms-menu';
export const SELECT_A_FIRM = 'Select a firm';
export const FILTER_FIRM_NUMBER = 9;
export const SELECT_FIRM = 'Select a Firm to Switch:';
